export default {
  common: {
    button: {
      action: "Actions",
      unread: "Mark as unread",
      read: "Mark as read",
      archive: "Archive",
      restore: "Restore to email",
      delete_archive: "Delete",
      empty_archive: "Empty folder",
      selectAll: "Select all enquiries",
    },
    confirmationPopup: {
      cancel: "Cancel",
      empty: {
        confirm: "Yes",
        title: "Are you sure you want to empty this folder permanently?",
        content:
          "You will not be able to undo this action if you choose to continue.",
        cancel: "Cancel",
      },
      nextpage: {
        confirm: "Proceed",
        title: "You are moving away from your selected enquiry",
        content:
          "If you go to the next page, your previous selections will be removed. Are you sure you want to proceed?",
      },
      selectAll: {
        confirm: "Yes, proceed",
        title: "You are trying to select more than 50 enquiries",
        content:
          "If you select all the enquiries on this page, your previous selections will be removed. Are you sure you want to proceed?",
      },
    },
    alert: {
      read: {
        success:
          "{leadsCount} enquir{leadsCount, plural, =0 {y} =1 {y} other{ies}} successfully marked as read",
        fail: "{errorCount} of your enquiries failed to be marked as read",
      },
      unread: {
        success:
          "{leadsCount} enquir{leadsCount, plural, =0 {y} =1 {y} other{ies}} successfully marked as unread",
        fail: "{errorCount} of your enquiries failed to be marked as unread",
      },
      archive: {
        success:
          "{leadsCount} enquir{leadsCount, plural, =0 {y} =1 {y} other{ies}} successfully archived",
        fail: "{errorCount} of your enquiries failed to be marked as archive",
      },
      restore: {
        success:
          "{leadsCount} enquir{leadsCount, plural, =0 {y} =1 {y} other{ies}} restored and moved to Emails",
        fail: "{errorCount} of your enquiries failed to be restored and moved to Emails",
      },
      delete_archive: {
        success:
          "{leadsCount} enquir{leadsCount, plural, =0 {y} =1 {y} other{ies}} successfully deleted",
        fail: "{errorCount} of your enquiries failed to be deleted",
      },
      empty_archive: {
        success: "Successfully emptied the folder",
        fail: "Failed to empty the folder",
      },
    },
    leadsError: {
      heading: "You have no emails yet",
      subHeading: "Once you get emails, it’ll appear here",
    },
  },
};
